/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-11-16 14:04:21
 */
import { Button, notification, Radio, Row, Table } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../app/store"
import styles from "./PrisonData.module.css"
import { PrisonDataColumn } from "./columns"
import {
  exportPrisonListAsync,
  getPrisonListAsync,
  selectPrisonList,
} from "./PrisonDataSlice"
import { unwrapResult } from "@reduxjs/toolkit"

export const PrisonData = () => {
  const dispatch = useDispatch<AppDispatch>()

  const data = useSelector(selectPrisonList)

  const [time, setTime] = useState()

  useEffect(() => {
    dispatch(getPrisonListAsync({ scope: time }))
  }, [dispatch, time])
  return (
    <div className={styles.main}>
      <Row
        style={{ height: '100px', width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <h3 style={{ fontWeight: 'bold' }}>各个卫健委(局)监管数据总览</h3>
        <div>
          <Radio.Group
            defaultValue={time}
            value={time}
            onChange={(e: any) => {
              setTime(e.target.value)
            }}
            optionType='button'
            buttonStyle='solid'
          >
            <Radio.Button value={0}>近七天</Radio.Button>
            <Radio.Button value={1}>近30天</Radio.Button>
            <Radio.Button value={2}>近一年</Radio.Button>
            <Radio.Button>全部</Radio.Button>
          </Radio.Group>
          <Button
            type='primary'
            style={{ marginLeft: '10px' }}
            onClick={() => {
              dispatch(exportPrisonListAsync({ scope: time }))
                .then(unwrapResult)
                .then((res: any) => {
                  const blob = new Blob([res], {
                    type: 'application/vnd.ms-excel',
                  })
                  console.table(blob)

                  const fileName = '监管数据总览.xlsx'
                  const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
                  let elink = document.createElement('a')
                  if ('download' in elink) {
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = selfURL['createObjectURL'](blob)
                    document.body.appendChild(elink)
                    // 触发链接
                    elink.click()
                    selfURL.revokeObjectURL(elink.href)
                    document.body.removeChild(elink)
                  } else {
                    navigator.msSaveBlob(blob, fileName)
                  }
                })
                .then(() => {
                  notification.success({
                    message: '导出成功',
                    duration: 3,
                  })
                })
                .catch((res: any) => {
                  console.log('失败')
                })
            }}
          >
            导出
          </Button>
        </div>
      </Row>

      <div
        style={{ height: 'calc(100% - 100px)' }}
        className={styles.MedicalData}
      >
        <Table
          rowKey={(record) => record.id}
          className={styles.MedicalTable}
          pagination={false}
          bordered
          onChange={(pagination, filters, sorter) => {
            console.log(sorter)
          }}
          style={{ height: '100%' }}
          dataSource={data}
          columns={PrisonDataColumn()}
        ></Table>
      </div>
    </div>
  )
}
